import { getWithAuth, putWithAuth } from 'services/http.service';
import {
  GET_BUSINESS_ACCOUNT_PREFERENCES,
  GET_BUSINESS_ACCOUNT_METADATA,
  UPDATE_BUSINESS_ACCOUNT_PREFERENCES,
  UPDATE_BUSINESS_ACCOUNT_METADATA,
  GET_AFTER_STORE_HOURS,
  UPDATE_AFTER_STORE_HOURS,
  GET_BUSINESS_CONFIGURATIONS,
  SET_BUSINESS_CONFIGURATION,
} from './url.service';

export const getBusinessAccountPreferences = () => getWithAuth(GET_BUSINESS_ACCOUNT_PREFERENCES);
export const getBusinessAccountMetadata = () => getWithAuth(GET_BUSINESS_ACCOUNT_METADATA);
export const updateBusinessAccountPreferences = (preferences) =>
  putWithAuth(UPDATE_BUSINESS_ACCOUNT_PREFERENCES, { preferences });
export const updateBusinessAccountMetadata = (metadata) =>
  putWithAuth(UPDATE_BUSINESS_ACCOUNT_METADATA, { metadata });
export const getAfterStoreHours = () => getWithAuth(GET_AFTER_STORE_HOURS);
export const updateAfterStoreHours = (value) => putWithAuth(UPDATE_AFTER_STORE_HOURS, { value });
export const getBusinessConfigurations = (keys) =>
  getWithAuth(`${GET_BUSINESS_CONFIGURATIONS}?keys=${keys}`);
export const setBusinessConfiguration = (key, value, type) =>
  putWithAuth(SET_BUSINESS_CONFIGURATION, { key, value, type });
